export default __webpack_public_path__ + "static/media/CareEvent5-min.7fde353a.png";